import { render, staticRenderFns } from "./Flop.vue?vue&type=template&id=307c08be&scoped=true&"
import script from "./Flop.vue?vue&type=script&lang=js&"
export * from "./Flop.vue?vue&type=script&lang=js&"
import style0 from "./Flop.vue?vue&type=style&index=0&id=307c08be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307c08be",
  null
  
)

export default component.exports